import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function InteriorDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Interior Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Professional mobile interior car detailing services including deep cleaning, shampooing, steam sanitizing, and leather conditioning.'
  };
  return <ServicePageLayout title="Interior Car Detailing in Los Angeles & Ventura County" subtitle="Restore your vehicle's cabin to a factory-fresh feel with our comprehensive mobile interior detailing service. We come directly to your home or office." metaDescription="Expert mobile interior car detailing in Camarillo, Thousand Oaks, and Ventura County. Deep cleaning, stain removal, and steam sanitizing. Call (818) 381-9905." schema={schema} data-id="element-501">
      <p data-id="element-502">
        Your vehicle's interior is where you spend all your time driving. Over
        time, dirt, dust, spills, pet hair, and odors can accumulate, making
        your daily commute less enjoyable and potentially impacting your health.
        At Mike's Pro Detail, our <strong data-id="element-503">mobile interior car detailing</strong>{' '}
        service is designed to deep clean, sanitize, and restore your cabin to a
        like-new condition. Whether you're in Camarillo CA, Thousand Oaks, or
        anywhere in Ventura County, our fully equipped mobile unit brings
        premium interior detailing directly to your doorstep.
      </p>

      <h2 data-id="element-504">What Our Interior Detailing Includes</h2>
      <p data-id="element-505">
        We don't just wipe down surfaces; we perform a meticulous, multi-step
        deep cleaning process to ensure every crack and crevice is addressed.
        Our comprehensive interior detail includes:
      </p>

      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-506">
        <li className="flex items-start" data-id="element-507">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-508" />
          <span data-id="element-509">
            <strong data-id="element-510">Thorough Vacuuming:</strong> Deep extraction of dirt,
            debris, and pet hair from carpets, seats, floor mats, and the trunk
            area.
          </span>
        </li>
        <li className="flex items-start" data-id="element-511">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-512" />
          <span data-id="element-513">
            <strong data-id="element-514">Shampoo & Extraction:</strong> Hot water extraction and
            shampooing of fabric seats, carpets, and floor mats to lift deep-set
            stains and grime.
          </span>
        </li>
        <li className="flex items-start" data-id="element-515">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-516" />
          <span data-id="element-517">
            <strong data-id="element-518">Leather Cleaning & Conditioning:</strong> Safe, pH-balanced
            cleaning of leather seats followed by a premium conditioner to
            prevent cracking and fading.
          </span>
        </li>
        <li className="flex items-start" data-id="element-519">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-520" />
          <span data-id="element-521">
            <strong data-id="element-522">Steam Cleaning & Sanitization:</strong> High-pressure steam
            is used on vents, cup holders, and high-touch areas to kill bacteria
            and melt away sticky residue.
          </span>
        </li>
        <li className="flex items-start" data-id="element-523">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-524" />
          <span data-id="element-525">
            <strong data-id="element-526">Plastics & Vinyl Restoration:</strong> Cleaning and UV
            protection applied to the dashboard, door panels, and center console
            to restore a rich, non-greasy finish.
          </span>
        </li>
        <li className="flex items-start" data-id="element-527">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-528" />
          <span data-id="element-529">
            <strong data-id="element-530">Streak-Free Windows:</strong> Interior glass and mirrors are
            cleaned to a crystal-clear, streak-free shine for optimal
            visibility.
          </span>
        </li>
      </ul>

      <h2 data-id="element-531">The Benefits of Professional Interior Detailing</h2>
      <p data-id="element-532">
        Investing in a professional interior detail goes beyond just aesthetics.
        A clean interior significantly improves the air quality inside your
        vehicle by removing dust mites, allergens, and bacteria trapped in the
        upholstery and ventilation system. Furthermore, regular conditioning of
        leather and UV protection on plastics prevents premature aging,
        cracking, and fading caused by the intense Southern California sun. If
        you're planning to sell your vehicle, a pristine interior is one of the
        most effective ways to maximize its resale value.
      </p>

      <h2 data-id="element-533">Why Choose Mike's Pro Detail for Interior Detailing?</h2>
      <p data-id="element-534">
        When searching for "Mobile Auto Detailing Camarillo CA" or "Car
        Detailing Camarillo", you want a service that is reliable, meticulous,
        and convenient. Mike's Pro Detail stands out because we use only
        premium, eco-friendly products and professional-grade equipment like hot
        water extractors and commercial steam cleaners. We understand that your
        time is valuable, which is why our mobile detailing Ventura County
        service comes entirely to you—fully equipped with our own water and
        power supply. From Agoura Hills to Chatsworth, we deliver 5-star results
        without you ever having to leave your home or office.
      </p>
    </ServicePageLayout>;
}